import { createAction } from 'redux-actions'
import * as constants from './constants'

export const receiveEndUserCompanyData = createAction(constants.RECEIVE_END_USER_COMPANY_DATA)

export const fetchBulkConversationEnrichmentDataSuccess = createAction(constants.FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS)

export const fetchEnrichedCompanyData = createAction(constants.FETCH_ENRICHED_COMPANY_DATA)
export const fetchEnrichedCompanyDataPending = createAction(constants.FETCH_ENRICHED_COMPANY_DATA_PENDING)
export const fetchEnrichedCompanyDataSuccess = createAction(constants.FETCH_ENRICHED_COMPANY_DATA_SUCCESS)
export const fetchEnrichedCompanyDataNoResult = createAction(constants.FETCH_ENRICHED_COMPANY_DATA_NO_RESULT)
export const fetchEnrichedCompanyDataFailed = createAction(constants.FETCH_ENRICHED_COMPANY_DATA_FAILED)
export const fetchEnrichedCompanyDataCancelled = createAction(constants.FETCH_ENRICHED_COMPANY_DATA_CANCELLED)

export const fetchDecodedCondition = createAction(constants.FETCH_DECODED_CONDITION)
export const fetchDecodedConditionPending = createAction(constants.FETCH_DECODED_CONDITION_PENDING)
export const fetchDecodedConditionFailed = createAction(constants.FETCH_DECODED_CONDITION_FAILED)
export const fetchDecodedConditionCancelled = createAction(constants.FETCH_DECODED_CONDITION_CANCELLED)
export const fetchDecodedConditionSuccess = createAction(constants.FETCH_DECODED_CONDITION_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/actions.js